<template>
  <footer>
    <div class="container">
      <div class="row justify-content-end">
        <div class="col-4">
          <h3>Kontakt</h3>
          <hr/>
          <p>Katarzyna Bieńkowska</p>
          <p><a href="mailto:youngforever.biuro@gmail.com">youngforever.biuro@gmail.com</a></p>
          <p><a href="tel:+48691729207">+48 691 72 92 07</a></p>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-4">
            <p class="copyright">stworzył Jakub Bieńkowski &copy; {{ year }}</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'main-footer',
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../main.scss';

footer {
  margin: 0;
  margin-top: 5rem;
  padding: 2rem 10rem;
  border-top: 2px solid $gray-light;
  background-color: rgba($brand-secondary, 0.85);
  color: $white;
  font-size: $font-size-lg;

  h3 {
    color: $white;
  }

  p {
    color: $white;
  }

  a {
    color: $white;
  }

  hr {
    border: 0.2px solid $black;
  }
}

.copyright {
  @extend .text-right;
  margin-top: 2rem;
  font-size: $font-size-sm;
  font-weight: $font-weight-bold;
}
</style>



// WEBPACK FOOTER //
// MainFooter.vue?d931eae4